/* AE (BFCM 2026): Early Bird Pass amounts in the shopper's currency.
   Thresholds are set in USD ($100/$200/$300 -> $15/$30/$50 gift cards). The top currencies use fixed, rounded local
   amounts (FIXED, set 30 Oct 2026 from Shopify's rates; Ben asked for round numbers). Other currencies are converted at
   Shopify's current rate: thresholds rounded up, gift card amounts rounded to the nearest whole unit.
   Fills [data-ae-usd] amounts (Early Bird band) and the [data-ae-eb-cart] row in the cart drawer. */
(function () {
  if (window.__aeEarlyBird) return;
  window.__aeEarlyBird = true;
  var c = (window.Shopify && Shopify.currency) || {};
  var cur = c.active || 'USD';
  if (cur === 'USD') return;
  var rate = parseFloat(c.rate) || 1;
  var lang = document.documentElement.lang || 'en';
  function fmt(v) {
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v); }
    catch (e) { return v + ' ' + cur; }
  }
  var FIXED = {
    GBP: [[75, 10], [150, 25], [225, 40]],
    EUR: [[90, 15], [180, 25], [270, 45]],
    CAD: [[140, 20], [280, 45], [420, 70]],
    CHF: [[85, 15], [170, 25], [250, 40]],
    AUD: [[145, 20], [290, 45], [435, 75]]
  };
  var T = FIXED[cur] || [[100, 15], [200, 30], [300, 50]].map(function (x) { return [Math.ceil(x[0] * rate), Math.round(x[1] * rate)]; });
  var MAP = { 100: T[0][0], 200: T[1][0], 300: T[2][0], 15: T[0][1], 30: T[1][1], 50: T[2][1] };
  function amounts() {
    document.querySelectorAll('[data-ae-usd]:not([data-ae-done])').forEach(function (el) {
      var v = MAP[+el.dataset.aeUsd];
      if (v === undefined) return;
      el.textContent = fmt(v) + (el.dataset.aePost || '');
      el.dataset.aeDone = '1';
    });
  }
  function cartRow() {
    document.querySelectorAll('[data-ae-eb-cart]:not([data-ae-done])').forEach(function (el) {
      var total = (+el.dataset.total || 0) / 100, have = 0, next = null, i;
      for (i = 0; i < T.length; i++) { if (total >= T[i][0]) have = T[i][1]; else if (!next) next = T[i]; }
      var txt;
      if (!next) txt = 'Early Bird Pass: you’ve earned a ' + fmt(T[2][1]) + ' Black Friday gift card.';
      else if (have) txt = 'Early Bird Pass: ' + fmt(have) + ' Black Friday gift card earned. Spend ' + fmt(Math.ceil(next[0] - total)) + ' more for ' + fmt(next[1]) + '.';
      else txt = 'Early Bird Pass: spend ' + fmt(Math.ceil(next[0] - total)) + ' more for a ' + fmt(next[1]) + ' Black Friday gift card.';
      var t = el.querySelector('[data-ae-eb-text]'); if (t) t.textContent = txt;
      var f = el.querySelector('.ae-fdb__fill'); if (f) f.style.width = Math.min(100, Math.round(total / T[2][0] * 100)) + '%';
      el.hidden = false;
      el.dataset.aeDone = '1';
    });
  }
  var queued = false;
  function run() { queued = false; amounts(); cartRow(); }
  run();
  new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(run); } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
